import { without } from '@/globals';

import * as types from './mutation-types';

const mutations = {
  [types.CREATE_ADVERTISER](state, advertiser) {
    state.newAdvertiser = advertiser;
  },

  [types.UPDATE_ADVERTISERS_LIST](state, advertisers) {
    state.advertisers = [...advertisers].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  },

  [types.UPDATE_ADVERTISERS_WITH_BUYER_LIST](state, advertisers) {
    state.advertisersWithBuyer = [...advertisers].sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
    );
  },

  [types.UPDATE_ADVERTISER](state, advertiser) {
    if (state.advertisers.find((c) => c.id === advertiser.id) === undefined) {
      state.advertisers = [...state.advertisers, advertiser];
    } else {
      state.advertisers = [
        ...without(
          state.advertisers,
          state.advertisers.find((c) => c.id === advertiser.id),
        ),
        advertiser,
      ];
    }
  },

  [types.CREATE_ADVERTISER](state, advertiser) {
    state.newAdvertiser = advertiser;
  },

  [types.SAVE_ADVERTISER](state, advertiser) {
    if (state.advertisers.find((c) => c.id === advertiser.id) === undefined) {
      state.advertisers = [...state.advertisers, advertiser];
    }
  },

  [types.UPDATE_UNIQUE_ADVERTISERS_LIST](state, uniqueAdvertisers) {
    state.uniqueAdvertisers = uniqueAdvertisers;
  },
  [types.UPDATE_AVAILABLE_ADVERTISERS_LIST](state, uniqueAdvertisers) {
    state.availableUniqueAdvertisers = uniqueAdvertisers;
  },
};

export default mutations;
